/* istanbul ignore file */
import _ from 'underscore';

export const getJobResults = (jobId, statusFilter, skip, take, entity, odata) => {
  const urlTmpls = _.mapObject({
    getJobResults: '/Customers()/{{accountInUrl ? \'Accounts()/\' : \'\'}}BulkEditSessions(\'{{jobId}}\')/BulkEditResults?$top={{top}}&$skip={{skip}}',
  }, url => _.template(url));
  let url = urlTmpls.getJobResults({
    jobId,
    top: take,
    skip,
    accountInUrl: !entity || entity !== 'Account',
  });

  let filter = '';
  if (statusFilter === 'OnlyErrors') {
    filter = 'Errors/any() or EditorialErrors/any()';
  } else if (statusFilter ==='OnlySuccessful') {
    filter = 'not (Errors/any() or EditorialErrors/any())';
  }

  if (filter !== '') {
    url += urlTmpls.filterSuffix({
      statusFilter: filter,
    });
  }

  return odata.get(url);
};
